import { Alert, Container } from "@mui/material";

import { useTranslation } from "react-i18next";
import { Navigate, Route, Routes } from "react-router-dom";

import { AdminAppBar } from "@modules/administration/components/AdminAppBar";
import { getAdminRedirectPath } from "authorization/authorization.util";
import { useAuthenticatedUser } from "hooks/useAuthenticatedUser";
import useNetworkStatus from "hooks/UseNetworkStatus";

import adminRoutes from "./adminRoutes";

export function AdminLayout() {
  const { t } = useTranslation();
  const isOnline = useNetworkStatus();
  const { authUser } = useAuthenticatedUser();

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={(theme) => ({
        backgroundColor: theme.vars.palette.background.default,
        minHeight: "100vh",
      })}
    >
      <AdminAppBar authUser={authUser} />
      {!isOnline && (
        <Alert variant="filled" severity="error" sx={{ borderRadius: 0 }}>
          {t("No internet connection")}
        </Alert>
      )}
      <Routes>
        {adminRoutes.map((route) => (
          <Route
            key={"path" in route ? route.path : ""}
            path={route.path}
            element={route.element}
          />
        ))}
        <Route path={"*"} element={<Navigate to={getAdminRedirectPath()} />} />
      </Routes>
    </Container>
  );
}
